import React from 'react';
import { Modal, Descriptions, Button, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { invoiceService } from '../services';
import { formatCurrency } from '../utils/format';
import dayjs from 'dayjs';
import './InvoiceDetailModal.css';

interface InvoiceDetailModalProps {
  visible: boolean;
  invoiceId: string | null;
  onClose: () => void;
}

const InvoiceDetailModal: React.FC<InvoiceDetailModalProps> = ({
  visible,
  invoiceId,
  onClose,
}) => {
  const { data: invoice, isLoading } = useQuery({
    queryKey: ['invoice-detail', invoiceId],
    queryFn: () => {
      if (!invoiceId) throw new Error('No invoice ID provided');
      return invoiceService.getDetail(invoiceId);
    },
    enabled: !!invoiceId && visible,
  });

  const formatDateTime = (dateString: string) => {
    if (!dateString) return '';
    const date = dayjs(dateString);
    return date.format('DD/MM/YYYY HH:mm');
  };

  const handleDownload = () => {
    if (invoice) {
      // TODO: Implement download functionality
      console.log('Download invoice:', invoice.invoiceNumber);
    }
  };

  if (!invoice || isLoading) return null;

  return (
    <Modal
      title={`Chi tiết hóa đơn ${invoice.invoiceNumber}`}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Đóng
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
        >
          Tải về
        </Button>,
      ]}
      width={800}
      className="invoice-detail-modal"
    >
      <Descriptions bordered column={1} className="invoice-details">
        <Descriptions.Item label="Số hóa đơn">
          {invoice.invoiceNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Tên khách hàng">
          {invoice.customerName}
        </Descriptions.Item>
        <Descriptions.Item label="CCCD/MST">
          {invoice.idCard}
        </Descriptions.Item>
        <Descriptions.Item label="Dịch vụ">
          {invoice.service}
        </Descriptions.Item>
        <Descriptions.Item label="Tổng tiền">
          <span style={{ fontWeight: 600, fontSize: 16, color: '#385da4' }}>
            {formatCurrency(invoice.totalAmount)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Ngày tạo đơn">
          {formatDateTime(invoice.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày gửi đơn">
          {formatDateTime(invoice.sentDate)}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default InvoiceDetailModal;

